define([
  'angular',
  'mod',
  'angular-cookies',
  'common/User/User',
  'common/Overlays/Overlays',
], function(angular, mod) {

var m = require('am');

m.config(['$httpProvider', function($httpProvider) {
  $httpProvider.interceptors.push('failedAuthInterceptor');
}]);

m.factory('failedAuthInterceptor', ['$q', '$rootScope', function($q, scope) {
  /*
  Registers an interceptor to catch failing ajax requests due to an expired
  session. An event is broadcast and the request is appended to a queue to be
  cleaned up by the handler registered below.
  */
  return {
    responseError: function(rejection) {
      if (rejection.status === 401 && rejection.data.message === 'Login Required') {
        var deferred = $q.defer();
        scope.$broadcast('authRequired');
        scope.requests_pending_auth = scope.requests_pending_auth || [];
        scope.requests_pending_auth.push({
          deferred: deferred,
          request: angular.copy(rejection.config)
        });
        return deferred.promise;
      }
      return $q.reject(rejection);
    }
  };
}]);

m.run(['$http', '$rootScope', '$window', 'throttle', '$cookieStore', 'loginService',
 function($http, $rootScope, $window, throttle, $cookieStore, loginService) {
  /*
  Sets up an event handler for cases in which the user's session has expired. It
  will attempt to request their password and log them in. If this is successful,
  it will attempt to rerun all of the failed ajax calls and fulfill their
  original promises.
  */
  var public_state;
  var stop_watching = $rootScope.$on('$stateChangeStart',
   function(ev, toState) {
    if (toState.data && toState.data.public) {
      public_state = true;
      stop_watching();
    }
  });
  var retry_request = function(request, deferred) {
    $http(request).then(function(result) {
      deferred.resolve(result);
    });
  };
  $rootScope.$on('authRequired', throttle(function() {
    if (public_state) {
      return;
    }
    loginService.login_user({username: $cookieStore.get('username')})
      .then(function() {
        // Popping the pending request in the while() to avoid race conditions
        var pending;
        while ((pending = $rootScope.requests_pending_auth.pop())) {
          retry_request(pending.request, pending.deferred);
        }
      })
      .catch(function(reason) {
        if (reason !== 'canceled') {
          $window.location.href = '/';
        }
      });

  }, 10 * 1000, {trailing: false}));
  // Don't run this function again if the event fires again within 10 seconds of the first.
}]);

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

m.factory('loginService', ['$q', '$http', 'modalForm', 'config', '$window', '$rootScope', 'change_password', '$api', '$state',
 function($q, $http, modalForm, config, $window, $rootScope, change_password, $api, $state) {

  function request_login(username, password) {
    /*
    Returns a promise for the result of an ajax request to login with the given credentials.
    */
    var deferred = $q.defer();
    $http.post('/n/account/api/', {username: username, password: password})
      .then(function(response) {
        $api.get('/n/account/api/').then(function(user) {

          //
          // If there's a "next" query string parameter on our current URL location
          // then honor the post-login redirect request
          //
          next_url = getParameterByName('next');
          if (next_url.length > 0) {
            window.location = next_url;
            return;
          }

          deferred.resolve(_.assign(user, response.data));
        });
      })
      .catch(function(response) {
        deferred.reject(response.data);
      });
    return deferred.promise;
  }

  function login_user(opts) {
    /*
    Takes a username, prompts them for their password using a modal form and
    sends a login request using the resulting credentials. Returns a promise for
    the resulting response.
    */
    if (opts.failure_message) {
      try {
        opts.failure_message = opts.failure_message.replace(/^[\s"]+|[\s"]+$/gm,'');
      } catch(e) {
        opts.failure_message = 'Login error';
      }
    }

    var promise = modalForm({
      template: require('common/Login/login_user.html'),
      message: opts.message,
      failure_message: opts.failure_message,
      username: opts.username,
      sso_domain: config.logins.google && config.logins.google.domain,
      allow_registration: config.logins.allow_registration,
      google_login: function() {
        var redirectUrl = $window.location.href.split('#')[0];
        var url = config.logins.google.url + '&state=' + escape(redirectUrl);
        $window.location.href = url;
        return true;
      }
    });
    return promise.then(function(results) {
      return request_login(results.username, results.password)
        .then(function(user) {
          if (user.password_reset) {
            return change_password(user, results.password).then(function() {
              return user;
            }).catch(function() {
              return user;
            });
          }
          window.current_user = user;
          return user;
        })
        .then(function(user) {
          $rootScope.$emit('userLoginSuccess');
          return user;
        })
        .catch(function(reason) {
          return login_user({username: results.username, failure_message: reason});
        });
    });
  }

  return {
    login_user: login_user,
    request_login: request_login
  };
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Login/Login.js
 **/